import React, { useState, useEffect } from 'react';
import { Row, Col, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { ReactComponent as ConvertIcon } from '../../../../../assets/icons/convert-icon.svg';
import { ReactComponent as PurchaseCar } from '../../../../../assets/icons/purchase-car.svg';
import toolKitArr from '../../../../../constants/toolKitData';
import { useDispatch } from 'react-redux';
import action from '../../../../../redux/action';
import sentGAEvent from '../../../../../ga';
import utils from '../../../../../../../utils/utils';
import { useSelector } from 'react-redux';
import VipIcon from '@/views/account/assets/images/vip-icon.png';
import NoVipIcon from '@/views/account/assets/images/novip-icon.png';
import pricingUrl from '../../../../../../../constants/pricingUrl';
import { requsetGetAllSubscription } from '../../../../../api/apis';
const ProfileRender = () => {
  const { t } = useTranslation('upgradePersonal');
  const [hoverSelect, setHoverSelect] = useState(-1);
  const [toolKitArrData, setToolKitArrData] = useState([]);
  const dispatch = useDispatch();
  const actionArr = {
    videoEnhancer: '04VE_UpgradePrompShow',
    photoEnhancer: '05PE_UpgradePrompShow',
    videoRemoveWaterMark: '01VWR_UpgradePrompShow',
    backgroundRemover: '08BR_UpgradePrompShow',
    removeTTWaterMark: '03TWR_UpgradePrompShow',
    dynamicPhoto: '22AO_UpgradePrompShow',
  };
  const subscriptionData =
    useSelector((state) => state.account.allSubscription) || null;
  const orderData = useSelector((state) => state.account.subscription) || null;

  useEffect(() => {
    requsetGetAllSubscription().then((res) => {
      console.log(res);
      if (res.code === 200) {
        console.log('allRes..............', res);
        dispatch(action.getAllSubscription(res.data.subscription));
      }
    });
  }, []);

  useEffect(() => {
    console.log('第一次打印', subscriptionData, orderData);
    let data = [...toolKitArr].map((item) => {
      return {
        ...item,
        isVip: false,
      };
    });

    if (subscriptionData !== null && orderData !== null) {
      let mergeArray = Array.from(new Set([...subscriptionData, ...orderData])); //集合去重复，然后转数组
      mergeArray.forEach((item) => {
        for (let i = 0; i < toolKitArr.length; i++) {
          if (data[i].nameArr.includes(item.product_name)) {
            // 如果匹配，则将isVip属性插入到对应的obj属性中
            data[i].isVip = item.status === 'Active' ? true : false;
          }
        }
      });
    }
    setToolKitArrData(data);
  }, [subscriptionData, orderData]);

  const linkToPricing = () => {
    // window.open(pricingUrl);
    window.open('https://online.hitpaw.com/pricing.html');
  };
  const openPurchase = (item) => {
    let key = item.key;
    sentGAEvent({
      category: 'UpgradePrompShow',
      action: actionArr[key],
      label: `V2Tools_${utils.systemCheck()}`,
    });

    if (item.isVip && item.key === 'videoEnhancer') {
      dispatch(
        action.onOpenPack({
          open: true,
          type: item.key,
        })
      );
    } else {
      dispatch(
        action.onOpenToolsPurchase({
          open: true,
          fromSource: key,
        })
      );
    }
  };

  return (
    <div className='allTools'>
      <div className='toolsBanner'>
        <div className='bannerTitle'>
          {t('bannerTitle')} <span className='off'>50% off</span>
        </div>
        <div className='content'>{t('introduct')}</div>
        <div onClick={() => linkToPricing()} className='upgrade'>
          {t('Upgrade')}
        </div>
      </div>
      <div className='toolsTitle'>{t('PopularTools')}</div>
      <div className='toolsContainer'>
        <Row
          style={{ width: '100%' }}
          gutter={[16, 8]}
          justify='flex-start'
          align='middle'
        >
          {toolKitArrData.map((item, value) => {
            return (
              <Col span={6}>
                <div
                  onMouseEnter={() => {
                    setHoverSelect(value);
                  }}
                  onMouseLeave={() => {
                    setHoverSelect(-1);
                  }}
                  className='productCard'
                >
                  <img
                    alt=''
                    className='productImg'
                    src={
                      hoverSelect === value ? item.afterImag : item.beforeImg
                    }
                  ></img>
                  <img
                    alt=''
                    className='vipIcon'
                    src={item.isVip ? VipIcon : NoVipIcon}
                  />
                  <div className='purchaseBtn'>
                    <Button
                      onClick={() => {
                        sentGAEvent({
                          category: 'Referral',
                          action: 'V2Tools_Referral',
                          label: `ToFun${value + 1}`,
                        });
                        window.open(item.url);
                      }}
                      type='ghost'
                      className='ghostBtn'
                    >
                      {item.btn}
                    </Button>
                    <Button
                      className='upgradeBtn'
                      onClick={() => openPurchase(item)}
                      style={{
                        background: '#6B57FF',
                        borderRadius: 6,
                      }}
                    >
                      <PurchaseCar style={{ margin: '0 10' }} />
                    </Button>
                  </div>
                  <div className='whiteCard'>
                    <div className='CardHeader'>
                      <div className='icon'>
                        <item.icon className='productIcon'></item.icon>
                      </div>

                      <div className='productTitle'>{item.productName}</div>
                    </div>
                    <div className='CardBody'>{item.content}</div>
                  </div>
                </div>
              </Col>
            );
          })}
        </Row>
      </div>
    </div>
  );
};

export default ProfileRender;
